import axios from 'axios';
import { API_BASE_URL, endpoints } from './config';

const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  params: { lang: 'en' }, // Default language
});

export const fetchAlerts = async ({ severity, dateRange, page, lang }) => {
  try {
    const response = await apiClient.get(endpoints.alerts.list, {
      params: {
        severity,
        start_date: dateRange?.start,
        end_date: dateRange?.end,
        page: page || 1,
        lang,
        ordering: '-created_at',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching alerts:', error);
    throw new Error(error.response?.data?.detail || 'Failed to fetch alerts');
  }
};

export const fetchAlertDetails = async (slug, lang) => { 
  try {
    const response = await apiClient.get(endpoints.alerts.detail(slug), { 
      params: { lang },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching alert details:', error);
    throw new Error(error.response?.data?.detail || 'Failed to fetch alert details');
  }
};